import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadTransmittalActions'
import * as api from '../../api/lead/transmittals'

import { fetchLeadDetails } from '../leadDetails'

function* leadTransmittalsRefresh(action) {
  try {
    const payload = yield call(api.getLeadTransmittals, action.leadId)
    yield put({ type: constants.LEAD_TRANSMITTALS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_TRANSMITTALS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchLeadTransmittals() {
  yield takeLatest(constants.LEAD_TRANSMITTALS_REFRESH.ACTION, leadTransmittalsRefresh)
}

function* sagaCreateLeadTransmittal(action) {
  try {
    const payload = {
      transmittal_data: {
        description: action.content.description,
        attention: action.content.attention,
        organization_id: action.content.organization_id,
        lead_id: action.leadId,
        created_by_id: action.userId,
        updated_by_id: action.userId,
        sending_other_text: action.content.sending_other_text,
        transmitted_other_text: action.content.transmitted_other_text
      },
      sending_list: action.sending,
      transmittal_items: action.transmittalItems,
      transmitted_list: action.transmitted
    }
    yield call(api.createLeadTransmittal, payload)
    yield put({ type: constants.LEAD_TRANSMITTAL_CREATE.SUCCESS, payload })
    yield call(leadTransmittalsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_TRANSMITTAL_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLeadTransmittal() {
  yield takeLatest(constants.LEAD_TRANSMITTAL_CREATE.ACTION, sagaCreateLeadTransmittal)
}

function* sagaUpdateLeadTransmittal(action) {
  try {
    const payload = {
      transmittal_id: action.transmittalId,
      transmittal_data: {
        description: action.content.description,
        attention: action.content.attention,
        status: action.content.status,
        lead_id: action.leadId,
        created_by_id: action.userId,
        updated_by_id: action.userId,
        sending_other_text: action.content.sending_other_text,
        transmitted_other_text: action.content.transmitted_other_text
      },
      sending_list: action.sending,
      transmittal_items: action.transmittalItems,
      transmitted_list: action.transmitted
    }

    yield call(api.updateLeadTransmittal, payload)
    yield put({ type: constants.LEAD_TRANSMITTAL_UPDATE.SUCCESS, payload })
    yield call(leadTransmittalsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_TRANSMITTAL_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadTransmittal() {
  yield takeLatest(constants.LEAD_TRANSMITTAL_UPDATE.ACTION, sagaUpdateLeadTransmittal)
}

function* sagaDeleteLeadTransmittal(action) {
  try {
    const payload = {
      transmittal_id: action.transmittalId,
      leadId: action.leadId
    }
    yield call(api.deleteLeadTransmittal, payload)
    yield put({ type: constants.LEAD_TRANSMITTAL_DELETE.SUCCESS, payload })
    yield call(leadTransmittalsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_TRANSMITTAL_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadTransmittal() {
  yield takeLatest(constants.LEAD_TRANSMITTAL_DELETE.ACTION, sagaDeleteLeadTransmittal)
}

function* getTransmittalData(action) {
  try {
    const payload = yield call(api.getTransmittalData, action.transmittalId)
    yield put({ type: constants.GET_LEAD_TRANSMITTAL_DATA.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_TRANSMITTAL_DATA.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTransmittalData() {
  yield takeLatest(constants.GET_LEAD_TRANSMITTAL_DATA.ACTION, getTransmittalData)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      transmittalId: action.transmittalId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { transmittalId: action.transmittalId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.transmittalId)
    yield put({ type: constants.GET_LEAD_TRANSMITTAL_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_TRANSMITTAL_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_LEAD_TRANSMITTAL_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: action.userId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { transmittalId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      transmittalId: action.transmittalId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_LEAD_TRANSMITTAL_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { transmittalId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_LEAD_TRANSMITTAL_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_LEAD_TRANSMITTAL_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadTransmittals),

    fork(watchCreateLeadTransmittal),
    fork(watchUpdateLeadTransmittal),
    fork(watchDeleteLeadTransmittal),

    fork(watchGetTransmittalData),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadTransmittalSaga.js